// src/pages/AIZone.ts
import "./AIZone.css";
import { renderAIZoneSidebar } from "../components/AIZoneSidebar";
import { renderAIZoneSearchBar } from "../components/AIZoneSearchBar";

interface Message {
  role: "user" | "ai";
  text: string;
  timestamp?: Date;
}

let messages: Message[] = [];

export function renderAIZone() {
  const app = document.getElementById("app");
  if (!app) return;

  app.innerHTML = `
    <div class="ai-wrapper">
      <div id="ai-sidebar-container"></div>

      <div class="ai-main">
        <!-- Top Navigation -->
        <div class="ai-topnav">
          <div class="nav-left">
            <button class="hamburger" id="hamburger-btn">☰</button>
            <button class="nav-item active">AI Zone</button>
            <button class="nav-item">All</button>
            <button class="nav-item">Images</button>
          </div>

          <div class="nav-right">
            <div class="apps-dropdown">
              <button class="nav-item" id="apps-btn">Apps ▾</button>
              <div class="apps-menu" id="apps-menu" style="display: none;">
                <div class="app-item">💬 MeChat</div>
                <div class="app-item">📄 ADocs</div>
              </div>
            </div>
            <button class="signin-btn" id="signin-btn">Sign In</button>
          </div>
        </div>

        <div class="ai-chat-feed" id="chat-feed"></div>

        <div class="ai-chat-input">
          <div id="ai-searchbar-container"></div>
        </div>
      </div>
    </div>
  `;

  setupAIZoneEvents();
}

function setupAIZoneEvents() {
  // Sidebar
  const sidebarContainer = document.getElementById("ai-sidebar-container");
  if (sidebarContainer) renderAIZoneSidebar(sidebarContainer);

  // Search Bar
  const searchContainer = document.getElementById("ai-searchbar-container");
  if (searchContainer) {
    renderAIZoneSearchBar(searchContainer, handleSend);
  }

  // Hamburger
  document.getElementById("hamburger-btn")?.addEventListener("click", () => {
    document.getElementById("ai-sidebar")?.classList.toggle("open");
  });

  // Apps dropdown
  const appsBtn = document.getElementById("apps-btn");
  const appsMenu = document.getElementById("apps-menu");

  appsBtn?.addEventListener("click", (e) => {
    e.stopPropagation();
    if (appsMenu) {
      appsMenu.style.display =
        appsMenu.style.display === "block" ? "none" : "block";
    }
  });

  document.addEventListener("click", () => {
    if (appsMenu) appsMenu.style.display = "none";
  });

  // Sign In
  document.getElementById("signin-btn")?.addEventListener("click", () => {
    const next = encodeURIComponent(window.location.href);
    window.location.assign(
      `https://api.ayesearch.com/auth/ayesearch/login/?next=${next}`,
    );
  });

  renderMessages();
}

function renderMessages() {
  const feed = document.getElementById("chat-feed");
  if (!feed) return;

  feed.innerHTML = messages
    .map(
      (msg) => `
      <div class="ai-msg ${msg.role}">
        <div class="msg-content">${escapeHtml(msg.text)}</div>
      </div>
    `,
    )
    .join("");

  feed.scrollTop = feed.scrollHeight;
}

// Simple HTML escape
function escapeHtml(unsafe: string): string {
  return unsafe
    .replace(/&/g, "&amp;")
    .replace(/</g, "&lt;")
    .replace(/>/g, "&gt;")
    .replace(/"/g, "&quot;")
    .replace(/'/g, "&#039;");
}

async function handleSend(query: string) {
  if (!query.trim()) return;

  messages.push({ role: "user", text: query });
  renderMessages();

  const loadingId = `loading-${Date.now()}`;
  const feed = document.getElementById("chat-feed");

  // Add loading indicator
  const loadingHTML = `
    <div class="ai-msg ai" id="${loadingId}">
      <div class="typing-indicator">Thinking<span class="dots"></span></div>
    </div>`;
  feed!.insertAdjacentHTML("beforeend", loadingHTML);
  feed!.scrollTop = feed!.scrollHeight;

  try {
    const res = await fetch(
      `https://api.ayesearch.com/api/ai/overview/?q=${encodeURIComponent(query)}`,
    );

    if (!res.ok) throw new Error("API error");

    const data = await res.json();
    const text =
      typeof data.overview === "string"
        ? data.overview
        : "Sorry, I couldn't generate a response.";

    // Remove loading indicator
    document.getElementById(loadingId)?.remove();

    messages.push({ role: "ai", text });
    renderMessages();
  } catch (err) {
    document.getElementById(loadingId)?.remove();
    messages.push({
      role: "ai",
      text: "Error connecting to AI. Please try again later.",
    });
    renderMessages();
  }
}
